import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=061c4606&"
import script from "./ObjectCard.vue?vue&type=script&lang=ts&"
export * from "./ObjectCard.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports